import {
  FetchProactiveMessagesQuery,
  FetchProactiveMessagesQueryVariables,
  fetchProactiveMessages,
  graphqlCall,
} from '@akin-home/amplify';
import { ProactiveMessageResponse } from '../types';

export const queryProactiveMessages = async (
  params: FetchProactiveMessagesQueryVariables
) => {
  try {
    const { data } = await graphqlCall<FetchProactiveMessagesQuery>(
      fetchProactiveMessages,
      params
    );
    return JSON.parse(
      data.fetchProactiveMessages || '[]'
    ) as ProactiveMessageResponse[];
  } catch (ex) {
    return [];
  }
};
